import { useEffect, useState } from "react";
import { Link } from "react-router";
import {
  ClipboardList,
  Layers,
  NavItem,
  NavTree,
  NavTreeItem,
  Spinner,
  type NavItemProps,
} from "@repo/ui";
import { cn } from "@repo/utils";
import { useSidebarData } from "~/hooks/use-sidebar-data";
import { routes } from "~/lib/constants";
import { ScrollFadeArea } from "../../ui/scroll-fade-area";
import { NavItemRenderer } from "../nav-item-renderer";
import { useSidebarContext } from "../sidebar-context";

export const TasksSection = () => {
  const { sidebarData, isLoading } = useSidebarData();
  const { routeContext } = useSidebarContext();
  const { isActive, isChildRoute } = routeContext;

  const isTasksRoute = isChildRoute(routes.dashboard.tasks);
  const [isTasksOpen, setIsTasksOpen] = useState(isTasksRoute);

  useEffect(() => {
    setIsTasksOpen(isTasksRoute);
  }, [isTasksRoute]);

  const isTasksExpanded = isTasksRoute && isTasksOpen;

  return (
    <>
      <NavItem
        as={Link}
        to={routes.dashboard.taskManager}
        icon={
          <Layers
            className={cn("h-5 w-5", {
              "text-blue-600": !isActive(routes.dashboard.taskManager),
              "text-white": isActive(routes.dashboard.taskManager),
            })}
          />
        }
        label="Task Manager"
        isActive={isActive(routes.dashboard.taskManager)}
      />
      <div
        className={cn("flex flex-col", {
          "min-h-52 flex-1": isTasksExpanded,
        })}
      >
        <NavItem
          as={Link}
          to={routes.dashboard.tasks}
          icon={
            <ClipboardList
              className={cn("h-5 w-5", {
                "text-blue-600": !isTasksRoute,
                "text-white": isTasksRoute,
              })}
            />
          }
          label="Tasks"
          isActive={isTasksRoute}
          isParent={isTasksRoute}
          showChevron={isTasksRoute}
          defaultOpen={isTasksRoute}
          onClick={isTasksRoute ? () => setIsTasksOpen((prev) => !prev) : undefined}
        />

        {isTasksExpanded && (
          <ScrollFadeArea className="flex-1">
            <NavTree size="md">
              <NavTreeItem>
                {isLoading ? (
                  <div className="flex items-center gap-2 px-4 py-2 text-sm text-gray-500">
                    <Spinner className="h-4 w-4" />
                    <span>Loading tasks...</span>
                  </div>
                ) : sidebarData ? (
                  <NavItemRenderer
                    items={sidebarData as readonly NavItemProps[]}
                    showTreeLines={true}
                    showOptionDD={true}
                  />
                ) : (
                  <div className="flex items-center gap-2 px-4 py-2 text-sm text-gray-500">
                    <span>No tasks found</span>
                  </div>
                )}
              </NavTreeItem>
            </NavTree>
          </ScrollFadeArea>
        )}
      </div>
    </>
  );
};
